export { default } from './Microfrontend';
